import { MegaphoneSimple } from "@phosphor-icons/react";
import { useCallback, useState } from "react";

import { useLocale } from "~/hooks/locale";

import { Modal } from "../Modal";
import { FeedbackForm } from "./FeedbackForm";

export const FeedbackWidget: React.FC = () => {
  const { t } = useLocale();
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = useCallback(() => {
    setIsOpen(false);
  }, []);
  return (
    <>
      <div className="fixed bottom-1/2 right-0 z-10 origin-bottom translate-x-1/2 -rotate-90">
        <button
          data-umami-event="feedback_click"
          className="btn btn-info btn-sm origin-bottom rounded-b-none"
          onClick={() => {
            setIsOpen(true);
          }}
        >
          {t("feedback")}
          <MegaphoneSimple weight="bold" className="size-5 rotate-90" />
        </button>
      </div>
      <Modal isOpen={isOpen} onClose={closeModal}>
        <FeedbackForm />
      </Modal>
    </>
  );
};
